import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a drivers icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <DriversIcon width={12} />
 */
const DriversIcon = props => (
    <SvgIcon viewBox="0 0 48 48" {...props}>
        <path
            d="M40,30.2a5.08,5.08,0,0,1,1.7.3,3.33,3.33,0,0,0-1.2-1.4,61.5,61.5,0,
          0,0-8.8-3.7,13.55,13.55,0,0,1-15.4,0,61.5,61.5,0,0,0-8.8,3.7,2.76,2.76,0,0,
          0-1.2,1.4A4.67,4.67,0,0,1,8,30.2,5.78,5.78,0,0,1,12.7,33a19.69,19.69,0,0,1,
          22.7,0A5.27,5.27,0,0,1,40,30.2ZM14,14A10,10,0,1,1,24,24,10,10,0,0,1,14,14ZM8,
          32c-2.2,0-4,2.2-4,5s1.8,5,4,5,4-2.2,4-5S10.2,32,8,32Zm32,0c-2.2,0-4,2.2-4,
          5s1.8,5,4,5,4-2.2,4-5S42.2,32,40,32Zm-5.8,5.2a16.38,16.38,0,0,0-20.4.1v.3a5.87,
          5.87,0,0,1-.4,2.3,21.42,21.42,0,0,0,6,2.1,9.23,9.23,0,0,1,9.1,0,21.42,21.42,0,
          0,0,6-2.1,8.52,8.52,0,0,1-.4-2.3C34.2,37.5,34.2,37.4,34.2,37.2Z"
        />
    </SvgIcon>
)

DriversIcon.defaultProps = defaultProps

export { DriversIcon }
